
// @ts-nocheck



import { i18nText } from '@/locales';

import {lineAmount} from "@/UI/pages/visitsNew/Lib/money";
import {IVisitsListItem} from "@/entity/visits/visit.types";
import {DateTime, Duration, Interval} from "ts-luxon";
import {Vue} from "vue-property-decorator";
import {genDate, genTime} from "@/UI/pages/visitsNew/Lib/support";
import {parseDateFormatted} from "@/UI/lib/parseSupport";

export interface dragEventI {
    vData: RecordDataForm;
    time: {
        start: DateTime;
        end: DateTime;
    };
}

export interface ServiceData {
    price: number;
    quantity?: number;
    service: any | null;
    service_duration: string;
    service_id: number | null;
}

export interface checkTi {
    changed: boolean;
    newStart: string | number | null;
    newEnd: string | number | null;
}

export interface DateRec {
    start: number;
    end: number;
}

export interface DateRecDateTime {
    start: DateTime;
    end: DateTime;
}

export class RecordDataForm {
    id: number;
    status_id: number;
    salon_id: number;

    visit_dt: string | null;
    visit_dt_end: string | null;
    visit_date: string | null;
    visit_date_time: string | null;
    visit_date_time_start: any | null;
    visit_date_time_end: any | null;

    visit_duration: string | null;
    visit_duration_ft: any;

    comment: string | null;
    color: string | null;
    category: number | null;
    note: string | null;
    another_client: boolean | null;

    basket: any | null;

    //service_data: any[] | null;
    service_data: Array<ServiceData> | null;
    services: any[] | null;
    consumables_data: any[] | null;
    products: any[] | null;
    certificates: any[] | null;
    memberships: any[] | null;

    cosmetologists_id: number | null;
    product_id: number | null;
    certificate_id: number | null;
    membership_id: number | null;
    notification_id: number | null;
    history_changes_id: number | null;
    payment_id: number | null;
    total_amount: number | null;

    client_id: number | string | null;

    client_name: string | null;
    client_phone: string | null;
    client_source: number[] | null;
    client_email: string | null;

    cosmetologist_fio: string | null;
    staff_position: string;

    clienta_change_date: any[] | null;

    visit_general_flag: boolean;
    service_visits_group: any[] | null;

    certificates_info: any[] | null;
    memberships_info: any[] | null;

    paid: any | null;
    sold: any | null;

    client_visit_info: {
        count_visits: number;
        visit_last_date: string;
    };

    new_client: boolean;

    //worker_schedule: boolean;
    worker_schedule_break_time: boolean;
    worker_schedule_not_work_day: boolean;

    startDate: DateTime;
    finishDate: DateTime;

    startDatehhMM: string;
    finishDatehhMM: string;

    constructor() {
        this.id = 0;
        this.status_id = 1;
        this.salon_id = 0;

        this.visit_dt = null;
        this.visit_dt_end = null;
        this.visit_date = "";
        this.visit_date_time = null;
        this.visit_date_time_start = null;
        this.visit_date_time_end = null;

        this.visit_duration = null;
        this.visit_duration_ft = {};

        this.staff_position = 'staff';

        this.comment = null;
        this.color = null;
        this.category = null;
        this.note = null;
        this.another_client = null;

        this.service_data = [];
        this.services = null;
        this.consumables_data = null;
        this.products = null;
        this.certificates = null;
        this.memberships = null;

        this.cosmetologists_id = null;
        this.product_id = null;
        this.certificate_id = null;
        this.membership_id = null;
        this.notification_id = null;
        this.history_changes_id = null;
        this.payment_id = null;
        this.total_amount = 0;

        this.client_id = null;

        this.client_name = null;
        this.client_phone = null;
        this.client_source = [];
        this.client_email = null;

        this.cosmetologist_fio = null;

        this.clienta_change_date = null;

        this.visit_general_flag = false;
        this.service_visits_group = null;

        this.certificates_info = null;
        this.memberships_info = null;

        this.paid = null;
        this.sold = null;

        this.client_visit_info = {
            count_visits: 0,
            visit_last_date: "",
        };

        this.new_client = false;
        this.basket = null;

        //this.worker_schedule = false;
        this.worker_schedule_break_time = false;
        this.worker_schedule_not_work_day = false;

        this.startDate = DateTime.now();
        this.finishDate = DateTime.now();

        this.startDatehhMM = "";
        this.finishDatehhMM = "";
    }

    async setQuantity(value: any, index: number): Promise<void> {
        // @ts-ignore
        this.service_data[index]["quantity"] = value;
    }

    exportFormatedDates(): { startDt: DateTime | null; endDt: DateTime | null } {
        const pDate = parseDateFormatted(this.visit_date + "," + this.visit_date_time_start),
            pDateEnd = parseDateFormatted(this.visit_date + "," + this.visit_date_time_end);

        if (pDate !== null && pDateEnd !== null) {
            const startDt = DateTime.local(
                    Number(pDate.year),
                    Number(pDate.month),
                    Number(pDate.day),
                    Number(pDate.hours),
                    Number(pDate.minutes),
                ),
                endDt = DateTime.local(
                    Number(pDateEnd.year),
                    Number(pDateEnd.month),
                    Number(pDateEnd.day),
                    Number(pDateEnd.hours),
                    Number(pDateEnd.minutes),
                );
            return {
                startDt: startDt,
                endDt: endDt,
            };
        } else {
            return {
                startDt: null,
                endDt: null,
            };
        }
    }

    async prepareVisit(RecordParams: any, studioId: number): Promise<void> {
        this.service_data = [];
        this.salon_id = studioId;

        this.visit_dt = RecordParams["date"];

        this.visit_date = RecordParams["date"];
        this.visit_date_time = RecordParams["time"];

        this.visit_date_time_start = genDate(RecordParams["date"], RecordParams["time"]);
        this.visit_date_time_end = genDate(RecordParams["date"], RecordParams["time"]);
        this.visit_dt_end = RecordParams["visit_dt_end"];

        /*this.visit_date_time_start = RecordParams["time"];
        this.visit_date_time_end = RecordParams["time"];*/

        this.cosmetologists_id = Number(Vue.router.currentRoute.params["Worker"]);
    }

    async parseVisitData(visit: IVisitsListItem): Promise<void> {
        if (visit === null) {
            return;
        }

        Object.assign(this, visit);

        if (this.service_data === null) {
            this.service_data = [];
        }
        //this.service_data
        //const basket = this.basket;
        if (this.basket) {
            // @ts-ignore
            this.service_data = this.basket["services"];
            /*this.service_data?.map((service:any)=>{
                service['service_id'] = service['id']
            })*/
        }
        //this.visit_date_time_start = null
        if (visit["client"]) {
            this.client_name = visit["client"]["name"];
            this.client_phone = visit["client"]["phone"];
            if (visit["client"]["email"]) this.client_email = visit["client"]["email"];
            this.client_source = visit["client"]["source"];
        } else {
            // ----- legacy that sometimes popups as error fix (Starting line.) -----
            this.client_name = visit["client_name"];
            this.client_phone = visit["client_phone"];
            if (visit["client_email"]) this.client_email = visit["client_email"];
            this.client_source = visit["client_source"];
            // ----- legacy that sometimes popups as error fix (Ending line.) -----
        }

        // this.client_name = visit["client_name"];
        // this.client_phone = visit["client_phone"];
        // if (visit["client_email"]) this.client_email = visit["client_email"];
        // this.client_source = visit["client_source"];
        /*this.visit_date_time_start = visit["visit_dt_start"];
        this.visit_date_time_end = visit["visit_dt_end"];*/

        const startVisit = DateTime.fromSQL(visit["visit_dt"] as string).toLocal();
        //

        const endVisit = DateTime.fromSQL(visit["visit_dt_end"] as string).toLocal();
        // @ts-ignore
        this.visit_date_time_start = startVisit.toLocaleString(DateTime.TIME_24_SIMPLE);
        // @ts-ignore
        this.visit_date_time_end = endVisit.toLocaleString(DateTime.TIME_24_SIMPLE);

        this.visit_date = startVisit.toISODate();

        this.visit_date_time = startVisit.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
        this.visit_duration = endVisit.diff(startVisit, ["hours", "minutes"]).toFormat("hh:mm");
        this.visit_dt_end = visit["visit_dt_end"];

        //this.visit_duration = endVisit.diff(startVisit).toLocaleString(DateTime.TIME_24_SIMPLE);
        this.client_visit_info = {
            count_visits: 0,
            visit_last_date: "",
        };

        this.category = Number(this.category);
        if (this.category === 0) this.category = null;

        if (this.client_source === null) this.client_source = [];
    }

    // ***********
    //workersInVisits ---- this.$store.state["visits"]["workersInVisits"]
    checkDuration(
        form: RecordDataForm,
        workers: IVisitsListItem[] | undefined,
        visitId?: number,
        dRec?: DateRecDateTime,
    ): { result: boolean; times: any; breakTime?: any } {
        let result = false;
        const vStart = DateTime.fromSQL(form["visit_date_time_start"]),
            vEnd = DateTime.fromSQL(form["visit_date_time_end"]);

        const times: any = [];
        workers?.map((visit: IVisitsListItem) => {
            if (Number(visit.status_id) === 5) return;
            const start = DateTime.fromSQL(visit["visit_dt"] as string).toLocal(),
                end = DateTime.fromSQL(visit["visit_dt_end"] as string).toLocal();
            if (start.hour === vStart.hour && start.minute === vStart.minute) {
                result = true;
            }
            if (start.hour === vStart.hour && start.minute > vStart.minute) {
                result = true;
            }

            if (visitId && Number(visitId) !== 0) {
                if (Number(visit["id"]) !== Number(visitId)) {
                    times.push({
                        start: {date: start.toMillis(), hour: start.hour, minute: start.minute, time: start},
                        end: {date: end.toMillis(), hour: end.hour, minute: end.minute, time: end},
                        visitId: visit["id"],
                    });
                }
            } else if (visitId === undefined) {
                times.push({
                    start: {date: start.toMillis(), hour: start.hour, minute: start.minute, time: start},
                    end: {date: end.toMillis(), hour: end.hour, minute: end.minute, time: end},
                    visitId: visit["id"],
                });
            }
        });

        result = false;
        let breakTime = null;
        if (dRec) {
            if (times) {
                times.map((tm: any) => {
                    const interval = Interval.fromDateTimes(dRec.start, dRec.end);
                    if (
                        interval.contains(DateTime.fromMillis(tm.start.date)) ||
                        interval.contains(DateTime.fromMillis(tm.end.date))
                    ) {
                        result = true;
                        breakTime = tm;
                    }
                    console.log("Result ===== " + result);
                });
            }
        }
        return {result: result, times: times, breakTime: breakTime};
    }

    //mode 0 - startTime, 1 - endTime
    checkTimeInterval(mode: number, time: any, duration?: string): checkTi {
        const start = this.visit_date_time_start,
            end = this.visit_date_time_end;

        let newEnd = null,
            newStart = null,
            condition = null;
        let changed = false;

        if (mode === 0) {
            if (
                Number(time.split(":")[0]) !== Number(start.split(":")[0]) &&
                Number(time.split(":")[0]) >= Number(end.split(":")[0])
            ) {
                const durationH = Number(time.split(":")[0]) - Number(start.split(":")[0]);
                //durationM = Number(time.split(":")[1])-Number(start.split(":")[1]);
                if (Number(end.split(":")[0]) + durationH <= 23) {
                    changed = true;
                    newEnd = Number(end.split(":")[0]) + durationH;
                }
                if (Number(end.split(":")[0]) + durationH > 23) {
                    changed = true;
                    newStart = Number(start.split(":")[0]);
                }
            }

            if (
                Number(time.split(":")[0]) !== Number(start.split(":")[0]) &&
                Number(time.split(":")[0]) <= Number(end.split(":")[0])
            ) {
                let dt = DateTime.now().toLocal();
                dt = dt.set({hour: Number(time.split(":")[0]), minute: Number(time.split(":")[1])});
                if (duration) {
                    dt = dt.plus({hour: Number(duration.split(":")[0]), minute: Number(duration.split(":")[1])});
                }
                changed = true;
                newStart = time;
                newEnd = dt.toLocaleString(DateTime.TIME_24_SIMPLE as any);
            }
        }
        if (mode === 1) {
            if (
                Number(time.split(":")[0]) !== Number(end.split(":")[0]) &&
                Number(time.split(":")[0]) < Number(start.split(":")[0])
            ) {
                changed = true;
            } else {
                condition = 1;
                changed = true;
                let dt = DateTime.now().toLocal();
                dt = dt.set({hour: Number(time.split(":")[0]), minute: Number(time.split(":")[1])});
                newEnd = dt.toLocaleString(DateTime.TIME_24_SIMPLE as any);

                if (duration) {
                    dt = dt.minus({hour: Number(duration.split(":")[0]), minute: Number(duration.split(":")[1])});
                }
                newStart = dt.toLocaleString(DateTime.TIME_24_SIMPLE as any);
            }
        }

        if (changed) {
            if (mode === 0) {
                if (newEnd && !newStart && !duration) {
                    newEnd = newEnd + ":" + time.split(":")[1];
                }
                if (newStart && !newEnd && !duration) {
                    newStart = newStart + ":" + time.split(":")[1];
                }
            }
            if (mode === 1) {
                if (!condition) {
                    newEnd = end;
                }
            }
        }

        return {
            changed: changed,
            newStart: newStart,
            newEnd: newEnd,
        };
    }

    async setVisitDt(startTime: string, endTime: string): Promise<void> {
        this.visit_dt = this.visit_date + ' ' + startTime;
        this.visit_dt_end = this.visit_date + ' ' + endTime;
    }

    async parseDuration(freezeServices?: boolean, startTime?: any, endTime?: any): Promise<void> {
        let dt = DateTime.now();


        if (Number(Vue.router.currentRoute.params["id"]) !== 0) {
            dt = DateTime.fromSQL(this.visit_dt as string).toLocal();
        } else {
            if (this.visit_dt && this.visit_dt.length > 0) {
                dt = DateTime.fromISO(this.visit_dt.substr(0, 10) as string, {locale: "ru"});
            }
            //dt = DateTime.now();
            let time: string[] = [];
            if (this.visit_date_time) {
                time = this.visit_date_time.split(":");
                dt = dt.set({hours: Number(time[0]), minutes: Number(time[1])});
            }
            //visit_date_time
        }
        if (startTime) {
            if (startTime.length === 16) {
                dt = dt.set({
                    hours: Number(startTime.substr(11, 2)),
                    minutes: Number(startTime.substr(14, 2)),

                    year: Number(startTime.substr(0, 4)),
                    month: Number(startTime.substr(5, 2)),
                    day: Number(startTime.substr(8, 2)),
                })
            } else {
                dt = dt.set({
                    hours: Number(startTime.substr(0, 2)),
                    minutes: Number(startTime.substr(3, 2)),
                })
            }

            /*const time = startTime.split(":");
            dt = dt.set({ hours: Number(time[0]), minutes: Number(time[1]) });*/

            //TODO::возможно years заменить year
            // const pDate = parseDateFormatted(startTime);

            // if (pDate) {
            //     dt = dt.set({
            //         hours: pDate.hours,
            //         minutes: pDate.minutes,
            //         year: pDate.year,
            //         month: pDate.month,
            //         day: pDate.day,
            //     });
            // } else {
            //     console.log("Error Start Time");
            // }

            //dt = DateTime.fromFormat(startTime as string, 'dd.MM.yyyy, HH:mm:ss').toLocal();
        }

        const StartDate = dt;
        let dt2 = dt;

        if (freezeServices === false) {
            this.total_amount = 0;
            this.service_data?.map((sv: any) => {
                if (sv["service"] && sv["quantity"]) {

                    this.total_amount = Number(this.total_amount) + lineAmount(sv);

                    const time = sv["service"]["service_duration"].split(":");

                    for (let i_i = 0; i_i < Number(sv["quantity"]); i_i++) {
                        dt2 = dt.plus(Duration.fromObject({hours: Number(time[0]), minutes: Number(time[1])}));
                        dt = dt2;
                    }
                }
            })
        }

        this.startDate = StartDate;
        if (freezeServices === false) {
            this.finishDate = dt;
            if (this.service_data?.length === 0) {
                this.total_amount = 0;
            }
        } else {
            this.finishDate = DateTime.fromSQL(this.visit_dt_end as string).toLocal();
        }

        //this.visit_duration = dt.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
        //this.visit_duration = dt.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
        //this.visit_duration_ft = dt.toFormat('hh')

        if (!endTime) {
            // @ts-ignore
            this.visit_date_time_end = dt2.toLocaleString(DateTime.TIME_24_SIMPLE);
        } else {
            if (endTime.length === 16) {
                dt2 = dt2.set({
                    hours: Number(endTime.substr(11, 2)),
                    minutes: Number(endTime.substr(14, 2)),

                    year: Number(endTime.substr(0, 4)),
                    month: Number(endTime.substr(5, 2)),
                    day: Number(endTime.substr(8, 2)),
                })
            } else {
                dt2 = dt2.set({
                    hours: Number(endTime.substr(0, 2)),
                    minutes: Number(endTime.substr(3, 2)),
                })
            }

            // const pDate = parseDateFormatted(endTime);
            //dt = DateTime.now();

            // if (pDate) {
            //     dt2 = dt2.set({
            //         hours: pDate.hours,
            //         minutes: pDate.minutes,

            //         year: pDate.year,
            //         month: pDate.month,
            //         day: pDate.day,
            //     });
            // } else {
            //     console.log("error set EndTime");
            // }

            // @ts-ignore
            this.visit_date_time_end = dt2.toLocaleString(DateTime.TIME_24_SIMPLE);
        }
        if (freezeServices === true && startTime === undefined) {
            // @ts-ignore
            this.visit_date_time_end = this.finishDate.toLocaleString(DateTime.TIME_24_SIMPLE);
        }

        // @ts-ignore
        this.visit_date_time_start = StartDate.toLocaleString(DateTime.TIME_24_SIMPLE);
        let diff = Interval.fromDateTimes(StartDate, dt2);

        //TODO::под вопросом
        //if (freezeServices === true && startTime===undefined) {

        if ((freezeServices && startTime === undefined) || endTime) {
            if (!endTime) {
                const dtEnd = this.visit_dt_end;
                diff = Interval.fromDateTimes(StartDate, DateTime.fromSQL(dtEnd as string));
                dt2 = DateTime.fromSQL(dtEnd as string);
            } else {
                /*diff = Interval.fromDateTimes(StartDate, DateTime.fromSQL(endTime as string));
                dt2 = DateTime.fromSQL(endTime as string);*/
                diff = Interval.fromDateTimes(StartDate, dt2);
                // @ts-ignore
                this.visit_date_time_end = dt2.toLocaleString(DateTime.TIME_24_SIMPLE);

                /*
                this.visit_dt_end = dt2.get('year')+'-'+dt2.get('month')+'-'+dt2.get('day');*/

                this.visit_dt_end = dt2.toFormat("yyyy-MM-dd hh:mm");
            }
            this.visit_duration = dt2.diff(StartDate, ["hours", "minutes"]).toFormat("hh:mm");
        }

        if (diff.length("hours") >= 1) {
            this.visit_duration_ft = {
                hours: String(Math.round(diff.length("hours"))),
                minutes: String(diff.length("minutes")),
                // @ts-ignore
                Start: StartDate.toLocaleString(DateTime.TIME_24_SIMPLE),
                // @ts-ignore
                End: dt2.toLocaleString(DateTime.TIME_24_SIMPLE),
            };
        } else {
            this.visit_duration_ft = {
                hours: "0",
                minutes: String(diff.length("minutes")),
                // @ts-ignore
                Start: StartDate.toLocaleString(DateTime.TIME_24_SIMPLE),
                // @ts-ignore
                End: dt2.toLocaleString(DateTime.TIME_24_SIMPLE),
            };
        }

        //this.visit_duration = String(diff.length('hours'))+':'+String(diff.length('minutes'));
        const duration = dt2.diff(StartDate, ["hours", "minutes"]).toObject(); //=> { months: 1, days: 2 }
        this.visit_duration = genTime(Number(duration["hours"]), Number(duration["minutes"]));

        // @ts-ignore
        this.visit_date = StartDate.toISODate();
    }
}

const phone = (fiels: any, vale: any) => {
    return vale?.length > 10 ? true : false
    
}
const requiredServices = (field: unknown, value: (any)[] | null): boolean => {
    if (value && value.length > 0) {
        return true;
    }
    return false;
};
const checkServices = (field: unknown, value: (any)[] | null): boolean => {
    if (value && value.length > 0) {
        for (const service of value) {
            if (!service.service_id || service.service_id === 0 || service.service_id === null) {
                return false;
            }
        }
        return true;
    }
    return false;
};

export const FormRules = {
    client_phone: [{required: true, message: i18nText("Пожалуйста укажите клиента"), trigger: "change"}, {validator: phone, message: i18nText("Пожалуйста укажите номер телефона"), trigger: "change"}],
    client_name: [{required: true, message: i18nText("Пожалуйста укажите клиента"), trigger: "change"}],
    cosmetologists_id: [{required: true, message: i18nText("Пожалуйста укажите сотрудника"), trigger: "change"}],
    client_source: [{required: true, message: i18nText("Пожалуйста укажите источник"), trigger: "change"}],
    service_data: [{ validator: requiredServices, message: i18nText("Пожалуйста укажите услуги"), trigger: "change" }, { validator: checkServices, message: i18nText("Выберите услуги из списка"), trigger: "change" }],
};
